module.exports = __webpack_public_path__ + "static/img/sign-out.3bf80cc8.svg";